<div class="area-frame" (keydown)="onKeydown($event)">
  <div #canvas class="area-canvas" tabindex="0" role="application" aria-label="Karte zum Einzeichnen der Kampagnengebiete"></div>

  <div class="area-search">
    <label class="sr-only" for="area-place-search">Ort oder Stadtteil suchen</label>
    <div class="search-field">
      <ng-icon name="lucideSearch" size="16" aria-hidden="true" />
      <input
        hlmInput
        id="area-place-search"
        class="area-chrome [&:not(textarea)]:h-9 w-full pl-8 text-sm"
        type="search"
        autocomplete="off"
        placeholder="Ort oder Stadtteil suchen"
        [value]="query()"
        (input)="onQuery($any($event.target).value)"
        (keydown.escape)="results.set([])"
      />
    </div>
    @if (results().length || searchError()) {
      <div class="search-results area-chrome" role="listbox" aria-label="Suchergebnisse">
        @for (place of results(); track place.label) {
          <button hlmBtn variant="ghost" type="button" role="option" (click)="goTo(place)">{{ place.label }}</button>
        }
        @if (searchError()) { <p>{{ searchError() }}</p> }
      </div>
    }
  </div>

  <div class="area-controls area-chrome" role="group" aria-label="Kartensteuerung">
    <button hlmBtn variant="ghost" size="icon" class="size-8" type="button" (click)="zoom(1)" aria-label="Vergrößern" title="Vergrößern"><ng-icon name="lucidePlus" size="16" /></button>
    <button hlmBtn variant="ghost" size="icon" class="size-8" type="button" (click)="zoom(-1)" aria-label="Verkleinern" title="Verkleinern"><ng-icon name="lucideMinus" size="16" /></button>
  </div>

  <div class="area-bar area-chrome" role="status" aria-live="polite">
    @if (drawing()) {
      <p class="min-w-0 flex-1">
        @if (draft().length === 0) {
          Klicken Sie die erste Ecke des Gebiets in die Karte.
        } @else if (draft().length < 3) {
          Weitere Ecken setzen …
        } @else {
          Auf den ersten Punkt klicken oder <kbd>Enter</kbd>, um abzuschließen.
        }
      </p>
      @if (draft().length) {
        <button hlmBtn variant="ghost" size="sm" type="button" class="h-8 gap-1.5 px-2 text-xs" (click)="undoPoint()">
          <ng-icon name="lucideUndo2" size="14" />Punkt zurück
        </button>
      }
      @if (areas().length || draft().length) {
        <button hlmBtn variant="ghost" size="sm" type="button" class="h-8 px-2 text-xs" (click)="cancelDrawing()">Abbrechen</button>
      }
      <button hlmBtn size="sm" type="button" class="h-8 gap-1.5 px-3 text-xs" [disabled]="draft().length < 3" (click)="finishArea()">
        <ng-icon name="lucideCheck" size="14" />Fläche abschließen
      </button>
    } @else {
      <p class="min-w-0 flex-1">
        Ecke ziehen verschiebt · weißen Punkt ziehen fügt eine Ecke ein · Doppelklick auf eine Ecke entfernt sie
      </p>
      <button hlmBtn size="sm" type="button" class="h-8 gap-1.5 px-3 text-xs" (click)="startDrawing()">
        <ng-icon name="lucidePlus" size="14" />Weitere Fläche
      </button>
    }
  </div>
</div>

<div class="area-list" aria-label="Eingezeichnete Flächen">
  @for (size of areaSizes(); track $index; let i = $index) {
    <span class="area-chip" [class.is-selected]="selected() === i">
      <button type="button" class="area-chip-label" (click)="focusArea(i)" [attr.aria-label]="'Fläche ' + (i + 1) + ' anzeigen'">
        Fläche {{ i + 1 }}
        <span class="font-mono text-muted-foreground">{{ size.toLocaleString('de-DE', { maximumFractionDigits: 2 }) }} km²</span>
      </button>
      <button type="button" class="area-chip-remove" (click)="removeArea(i)" [attr.aria-label]="'Fläche ' + (i + 1) + ' entfernen'" title="Fläche entfernen">
        <ng-icon name="lucideX" size="12" />
      </button>
    </span>
  } @empty {
    <span class="text-xs text-muted-foreground">Noch keine Fläche eingezeichnet.</span>
  }
  @if (areas().length) {
    <span class="ml-auto font-mono text-xs" [class]="tooLarge() ? 'text-danger' : 'text-muted-foreground'">
      {{ totalKm2().toLocaleString('de-DE', { maximumFractionDigits: 2 }) }} / {{ maxKm2 }} km²
    </span>
  }
</div>
